import { CoreType, GenericTableSchemaInterface, UserVars, StoreVars } from '../../swivl-lib'
import { BotVariables } from '@swivl/swivl-worksheets-lib'

export const UnhandledsDuringProfileCollect00Table: GenericTableSchemaInterface = {
  id: 'unhandleds-during-profile-collect-00',
  name: 'Unhandleds During Profile Collect 00',
  description:
    'This table contains unhandled utterances while we were asking users for their information',
  core: CoreType.STORAGE,
  // bot:"all",
  mapping: {
    c01: {
      name: 'Operator Name',
      variable: BotVariables.Bot_Operator_Name
    },
    c02: {
      name: 'Facility ID',
      variable: StoreVars.StoreId
    },
    c03: {
      name: 'User ID',
      variable: UserVars.User_Id
    },
    c04: {
      name: 'Store Name',
      variable: StoreVars.StoreName
    },
    c05: {
      name: 'Last Input' // cannot find this var in the code but I can type it in swivlStudio
    }
  }
}
